import axios from 'axios';
import { handleUnauthorizedStatus } from './sessionRedirect';
import { currentSite } from './brandSession';

const authenticatedAxios = axios.create();

authenticatedAxios.interceptors.request.use(config => {
  const authorization = config.headers?.get?.('Authorization') || config.headers?.Authorization || config.headers?.authorization;
  config.authSite = currentSite();
  config.authToken = typeof authorization === 'string' && authorization.startsWith('Bearer ') ? authorization.slice(7) : null;
  return config;
});

authenticatedAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    handleUnauthorizedStatus(error.response?.status, {site: error.config?.authSite, token: error.config?.authToken});
    return Promise.reject(error);
  }
);

export default authenticatedAxios;